<template>
    <pre class="tabs">
<b>Tuning: EADGBe (Standard Tuning)

/  slide up
\  slide down
h  hammer-on
p  pull-off
b  bend
d  down
~  vibrato
+  harmonic
x  mute note

TAB:</b>

     PM PM                PM  PM PM
e|---------------------------------------------------------------|
B|----------------------------------------11-b14~x--(16)---14----|
G|----------------------------------11-13-------------------bd13-|
D|---11-11---11---11h13-------11-13------------------------------|
A|------------------------13-------------------------------------|
E|---------------------------------------------------------------|
           PM                            PM     PM
e|---------------------------------------------------------------|
B|---------------------12----------------------------------------|
G|11-13-11----11-13/15----13h15-13~-13p11------------11---13-11--|
D|---------13----------------------------13x----13---------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|
   PM   PM PM
e|---------------------------------------------------------------|
B|---------------12-12-11----------------------------------------|
G|------------10----------13-10-13-11~----10---------------------|
D|-13---11-12--------------------------13----12~---13/15-13~-----|
A|----------------------------------------------13---------------|
E|---------------------------------------------------------------|
   PM PM PM    PM PM PM PM PM PM PM PM PM PM PM PM PM PM PM
e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|----------11----------11----------11----------11---------------|
D|----11-13----13-11-------13-11-------13-11-------13-11----13-11|
A|-13----------------13----------13----------13----------13------|
E|---------------------------------------------------------------|
                    PM PM PM PM                         PM PM
e|---------------------------------------------------------------|
B|------------------------------14-13-12-14-10/11----------------|
G|---------------------------11-------------------13p11-------13-|
D|---------------11-------11----------------------------13p11----|
A|-13\11-9-11/13----13h14----------------------------------------|
E|---------------------------------------------------------------|

e|------------------------------------------------11-13p12p11\10-|
B|-----------------------------12-11------------11---------------|
G|10~--10h11p10----10----10-13-------10-13-10/11-----------------|
D|--------------13----12-----------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|13-11-11-11------------11-13-13/14~--13-11-14-13~-------13-----|
B|------------11x-----11----------------------------14-11----14--|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|-----------------------11x-------------------------------------|
B|11----14-12~-----11h12----12x-------11x------------------------|
G|---11-------------------------13p12----12x13-------11----------|
D|---------------------------------------------13p11----13b------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|-------------------------11---------11~x---11----11~x-----11-13|
B|-----------------------11---11-b14x-----11----11-------11------|
G|-----------11-13-11-b13----------------------------------------|
D|b13d-11-12-----------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|/14/16b-d-p14-16-14-b16x-16p14-16-16~-14~x--b16(18)d16p14-16-16|
B|---------------------------------------------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|b14x-b16(18)d16p14-16-16-b14xb14x14-13-16-14-16p14p13------13--|
B|-----------------------------------------------------16\15-----|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|-----11-----11-------------11----------------------------------|
B|-/11----b14----14-11-----11---14-11----------------------------|
G|---------------------b13------------b13x-d13p11----13p11----11h|
D|------------------------------------------------13-------13----|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

                       PM PM   PM  PM  PM  PM  PM  PM  PM  PM  PM
e|---------------------------------------------------------------|
B|--11-----------------------------------11--12--14--11--12--14--|
G|13-------------------------10--11--13--------------------------|
D|-----13p11----11h13--13-13---13--13--13--11--11--11--11--11--11|
A|-----------13--------------------------------------------------|
E|---------------------------------------------------------------|

e|------14-13----------------------------------------------------|
B|12p11-------14-11-------------11~-----------11----------11h12~-|
G|------------------11\10/11h13------13-11-------13-11-----------|
D|-----------------------------------------13----------13--------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------11----|
B|-----------11x12x13~--p11--------b13(14)-dp11------b14x-----14-|
G|-13-11--------------------13p11--------------13p11-------------|
D|-------13------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------11------------11------------11------------14-------14p|
B|-11-b14x----14-11-b14x----14-11-b14x----14-11-b14x----14-11----|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|11-----14p11-----14p11-14p11---11-----11-----------------------|
B|--14p11-----14p11-----------14----b14----14-11-----------------|
G|-----------------------------------------------14\13-11-13/14--|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------11-13-|
B|-11-11-11-11h12-----------------------------------11x-11-------|
G|----------------d13p11-13-13-11--d13-11-10-11-10~--------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|14-14-11h13~--11----11--------11-11-----11-14-16-14--b16x17-b16|
B|-----------------14----11-b14-------b14------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|16p14-16-b16-14h16~-14-13-16-13h16p13--13----------------------|
B|-------------------------------------14--14--14----------------|
G|-------------------------------------------13--13--------------|
D|-------------------------------------------------15\13-11x-13x-|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|--------------------------11----13-11-------------11--13d-p11--|
D|d13-p11-13-11----11x11h13----13-------13-11-13~--------------13|
A|--------------13-----------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|----------------------------------------------14---------------|
G|----13d-p11-------13d-p11-------13d-p11----------13d-p11-----11|
D|-11---------13-11---------13-11---------13-11------------13x---|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|------------11-13x-13x-14x-14x-15x-15x-16x-16x-b15x-16x-b15x-16|
B|------11-14----------------------------------------------------|
G|~-h13----------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|x-b15x-16x-14x-16x-14x-16x-16d-p14-16x-14x-16x-b16x-14x-16x----|
B|------------------------------------------------------------16~|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|-14------------------------------------------------------------|
B|----16-14\11-------------------------------------11-b11(12)-11-|
G|-------------13-11-------------11/12-12----12-13---------------|
D|-------------------13-11-13~------------13---------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|11-10/11-\9-7-7/9-11-9-----------------------------------------|
G|-----------------------11x-10~------------------11----13-11----|
D|-------------------------------12x-13x----11h13----13-------13-|
A|---------------------------------------13----------------------|
E|---------------------------------------------------------------|

e|---------------14x---------------------11-14x-b13-13p11-----11-|
B|5/8-9-11x-b12x----b12x-12~-11-12-11-12------------------14-----|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|14-16-16/18~--17/19--18-18-18-18-16h18-18-18-16h18-18-18-18-19-|
B|---------------------------------------------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|b19x-b19x-19~--b18x-d-18-16-19-18-16-14-b16d-16p14-b16---b16x--|
B|---------------------------------------------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|-16-14-h16p14-13-14-13-11-13-11----11-----11--------------11---|
B|--------------------------------11----b14----14-11-----11----14|
G|---------------------------------------------------b13---------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|-11------------------------14p11----------14p11----------14p11-|
G|----b13x-13p11----13p11----------13-11----------13-11----------|
D|---------------13-------13-------------13-------------13-------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------11-13----11-13-14-|
B|------14p11-------14p11------14p11-------b14-------11----------|
G|13-11-------13-11-------13-11------13-11-----------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---11-14-16-13-14-16-18-14-b16-b16-x-d16p14-b16----------------|
B|11-------------------------------------------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|


Final chorus:

B|---------------------------------------------------------------|
e|---------------------------------------------------------------|
G|-d13--p11----11h13~---p11--------------------------13~---------|
D|----------13--------------13/15-13~-----------------------13/15|
A|--------------------------------------13\11-9~x----------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|------------------------------------11x------------------------|
G|------------6---6h8~-p6-----------------11h13-11-10~-----------|
D|-11h13~-------8---------8\6p4------------------------11----11h-|
A|------------------------------6x------------------------13-----|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|--------------14\11~---6-7-9-----------------------------------|
G|-----------11-----------------6h8p6h8p6h8p6h8p6h8p6h8p6h8p6h8p6|
D|13~--11-13-----------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|--11---13---14--------11-13-b13-13-11----------------------13--|
B|-b14--b16--b17---8/11-----------------14-11-14p12~---12/14---14|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|14/16-------14------------14--------------------------11x------|
G|13/15--13/15--15\13p11-------15\13p11----11-13p11---------11h13|
D|-----------------------13-------------13----------13x----------|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|------------------------------14x------6-9-7-------------------|
G|-11-10~--------------------11-----b13--------6b--3h6p3----8----|
D|--------11----11h13--11-13-----------------------------6/8-8\6p|
A|-----------13--------------------------------------------------|
E|---------------------------------------------------------------|

e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|---------------------------------------------------------------|
D|4\3h4p3h4p3h4p3h4p3h4p3h4p3h4p3h6p3h6p3h6p3h6p3h6p3h4p3h4p3~---|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

Tab Written By: WATERMELONE
    </pre>
</template>
<script>
export default {
    name: 'Redbone'
}
</script>
